import { useCallback, useMemo, useState } from "react";

export interface ModalProps {
    visible: boolean;
    onCancel: () => void;
}

export type ShowModal = () => void;

// TODO - Refactor/rename this...
export const useToggleState = (visibleByDefault = false): [ModalProps, ShowModal] => {
    const [visible, setVisible] = useState(visibleByDefault);

    const showModal = useCallback(() => {
        setVisible(true);
    }, [setVisible]);

    const onCancel = useCallback(() => {
        setVisible(false);
    }, [setVisible]);

    const modalProps = useMemo(() => {
        return {
            visible,
            onCancel,
        };
    }, [visible, onCancel]);

    return [modalProps, showModal];
};
